import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { User, Receipt, Plane, HeartPulse, BookOpen, GraduationCap, MessageSquare, Clock, CalendarRange } from 'lucide-react';
import { MyInfoTab } from './MyInfoTab';
import { PayDocsTab } from './PayDocsTab';
import { TimeOffTab } from './TimeOffTab';
import { BenefitsTab } from './BenefitsTab';
import { PoliciesTab } from './PoliciesTab';
import { OnboardingTab } from './OnboardingTab';
import { RequestsTab } from './RequestsTab';
import { TimesheetTab } from './TimesheetTab';
import { MyScheduleTab } from './MyScheduleTab';

const TABS = [
  { value: 'info', label: 'My Info', icon: User, component: MyInfoTab },
  { value: 'pay', label: 'Pay & Tax', icon: Receipt, component: PayDocsTab },
  { value: 'timeoff', label: 'Time Off', icon: Plane, component: TimeOffTab },
  { value: 'benefits', label: 'Benefits', icon: HeartPulse, component: BenefitsTab },
  { value: 'policies', label: 'Policies & Docs', icon: BookOpen, component: PoliciesTab },
  { value: 'onboarding', label: 'Onboarding', icon: GraduationCap, component: OnboardingTab },
  { value: 'requests', label: 'HR Requests', icon: MessageSquare, component: RequestsTab },
  { value: 'timesheet', label: 'My Timesheet', icon: Clock, component: TimesheetTab },
  { value: 'schedule', label: 'My Schedule', icon: CalendarRange, component: MyScheduleTab },
];

export default function HRPortal() {
  return (
    <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-y-auto" data-testid="hr-portal">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-800 mb-1">HR Portal</h1>
        <p className="text-sm md:text-base text-slate-500">Your personal information, pay documents, time off, benefits and more</p>
      </div>

      <Tabs defaultValue="info" className="w-full">
        <TabsList className="flex flex-wrap h-auto gap-1 bg-slate-100 p-1 mb-6 justify-start">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value} className="gap-1.5 data-[state=active]:bg-white" data-testid={`hr-tab-${t.value}`}>
              <t.icon className="w-4 h-4" />
              <span className="hidden sm:inline">{t.label}</span>
              <span className="sm:hidden">{t.label.split(' ')[0]}</span>
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map((t) => (
          <TabsContent key={t.value} value={t.value}>
            <t.component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
